import type { PageMeta } from '@api/types'
import { useI18n } from '@i18n/I18nProvider'
import { Button } from '@ui/Button'

// Anterior / siguiente de un listado paginado. Con una sola página no se muestra.
export const Pager = ({ meta, onChange }: { meta: PageMeta; onChange: (page: number) => void }) => {
	const { t } = useI18n()
	if (meta.pages <= 1) return null
	return (
		<nav aria-label={t('pager.label')} className="mt-6 flex items-center justify-between gap-3">
			<Button variant="secondary" disabled={meta.page <= 1} onClick={() => onChange(meta.page - 1)}>
				{t('pager.previous')}
			</Button>
			<span className="text-earth-800">{t('pager.status', { page: meta.page, pages: meta.pages })}</span>
			<Button variant="secondary" disabled={!meta.hasMore} onClick={() => onChange(meta.page + 1)}>
				{t('pager.next')}
			</Button>
		</nav>
	)
}
